import script from "./PlayVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayVideo.vue?vue&type=script&setup=true&lang=js"

import "./PlayVideo.vue?vue&type=style&index=0&id=b71517d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b71517d8"]])

export default __exports__